import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Section } from '../section/section.model';

@Component({
  selector: 'section-based-toc',
  templateUrl: './section-based-toc.component.html',
  styleUrls: ['./section-based-toc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionBasedTocComponent implements OnInit {

  @Input() docData:any;
  @Input() isMobile = false;
  @Input() isSticky = false;

  showMoreButton = false;
  compteur = 0

  constructor() { }

  ngOnInit(): void {
    this.getSectionsWithTitle();  
  }

  getSectionsWithTitle() {
    var sectionsWithTitle = 0;
    for (var section of this.docData.sections) {
      if(section.title) {
        ++sectionsWithTitle;  
      }
    }
    if (sectionsWithTitle > 6) {
      this.showMoreButton = true;
    }
  }

  showFullToc(){
    this.showMoreButton = false;
  }
}
